// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

import Paper from '@mui/material/Paper'
import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import React from 'react'
import UserRow from './UserRow'
import css from './Users.css'
import type { User } from './userTypes'
type Props = {
  data: Array<{
    node: User
  }>
  onEdit: (...args: Array<any>) => any
  onDelete: (...args: Array<any>) => any
  refetch: (...args: Array<any>) => any
}

class UsersTable extends React.Component<Props> {
  render() {
    const { data, onEdit, onDelete, refetch } = this.props
    return (
      <Paper>
        <Table className={css.table} data-testid='users-table'>
          <TableBody>
            {data.map((row) => {
              return <UserRow key={row.node.id} data={row.node} onEdit={onEdit} onDelete={onDelete} refetch={refetch} />
            })}
          </TableBody>
        </Table>
      </Paper>
    )
  }
}

export default UsersTable
